<!-- <div class="cdiv"> -->
<div class="c">
    <div class="headerback">
        <!-- <button mat-icon-button aria-label="Example icon button with a vertical three dot icon" class="backbtn">
               <mat-icon>arrow_back</mat-icon>
             </button> -->

        <button mat-mini-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="backhome()">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>

    <img class="icon icon-user" src="assets/images/recycle.png">
    <div class="wrapper" style="direction: rtl;">
        <p class="title" style="justify-content: center;text-align: center;font-weight: bold;">
            تماس با ما</p>
        <div style="justify-content: right;">
            <p>شهروندان گرامی، در صورت داشتن هرگونه سوال می توانند با کارشناسان شرکت فولاد پارس شاهوار تماس بگیرند.
                همچنین کارشناسان اين شرکت، آماده میزبانی از شما همشهريان گرامی در محل دفتر شرکت به آدرس زير می باشند</p>
            <p>آدرس شرکت: شاهرود، میدان هفت تیر، جاده مغان، روبروی دفتر آب ابراهیمیان.</p>

        </div>
    </div>

</div>
<!-- </div> -->